import { render, staticRenderFns } from "./Buffer.vue?vue&type=template&id=2d034b6c&"
import script from "./Buffer.vue?vue&type=script&lang=js&"
export * from "./Buffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports